/**
 * Cleans a phone number by removing all non-numeric characters
 * @param phoneNumber - The phone number to clean
 * @returns The cleaned phone number containing only digits
 */
export const cleanPhoneNumber = (phoneNumber?: string | null): string => {
  if (!phoneNumber) return '';
  // Remove all non-numeric characters including +, spaces, (), -, etc
  return phoneNumber.replace(/\D/g, '');
};
